import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../breadcrumb";
import Header from "../../DashboardNavigation/header";
import Sidebar from "../../DashboardNavigation/sidebar";
import FileUpload from "../../FileUpload/FileUpload";
import { Button } from "../../ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "../../ui/form";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import {
  TeamFormValues,
  teamSchema,
  UpdateTeamFormValues,
  updateteamSchema,
} from "./team-zod-schema";
import {
  getTeamById,
  handleCreateTeam,
  handleUpdateTeam,
} from "../../../API/Team/teamService";

export const TeamForm: React.ComponentType<any> = () => {
  const router = useNavigate();
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

  const { id } = useParams();
  const initialData = id ? parseInt(id) : undefined;
  const [loading, setLoading] = useState(false);
  const title = initialData
    ? "Modifier l'organigramme"
    : " Ajouter un nouvel organigramme";
  const description = initialData
    ? "Modifier l'organigramme"
    : " Ajouter un nouvel organigramme";

  const action = initialData ? "Mise à jour" : "Ajouter";

  const form = useForm<TeamFormValues | UpdateTeamFormValues>({
    resolver: zodResolver(initialData ? updateteamSchema : teamSchema),
  });

  const onSubmit = async () => {
    setLoading(true);
    const formData = form.getValues();
    try {
      if (initialData) {
        await handleUpdateTeam(initialData, formData, router);
      } else {
        await handleCreateTeam(formData, router);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const [data, setData] = useState<any>();
  useEffect(() => {
    const fetchData = async () => {
      if (initialData) {
        const teamData = await getTeamById(initialData);
        setData(teamData);
        form.reset({
          image: teamData.image
            ? [
                {
                  fileName: teamData.image,
                  name: teamData.image,
                  fileSize: 0,
                  size: 0,
                  key: teamData.image,
                },
              ]
            : [],
        });
      }
    };

    if (initialData) {
      fetchData();
    }
  }, [initialData]);

  const breadcrumbItems = [
    { title: "Équipe", link: "/admin-dashboard/organigramme-equipe" },
    { title: "Ajouter", link: "/admin-dashboard/organigramme-equipe/nouveau" },
  ];

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="w-full p-10">
          <BreadCrumb items={breadcrumbItems} />
          <div className="flex items-center justify-between">
            <Heading title={title} description={description} />
          </div>
          <Separator />
          <Form {...form}>
            <form
              className="w-full space-y-8"
              onSubmit={form.handleSubmit(onSubmit)}
            >
              {data?.image && (
                <div className="mt-4 mb-4">
                  <img
                    src={`${uploadUrl}/team/${data.image}`}
                    alt="Old Image Preview"
                    className="w-10 h-10 h-auto"
                  />
                </div>
              )}
              <FormField
                control={form.control}
                name="image"
                render={() => (
                  <FormItem>
                    <FormControl>
                      <FileUpload
                        onChange={(files) => {
                          const mappedFiles = files.map((file) => ({
                            key: file.id,
                            fileName: file.fileName,
                            name: file.fileName,
                            fileSize: parseInt(file.fileSize),
                            size: parseInt(file.fileSize),
                            file: file.file,
                          }));
                          form.setValue("image", mappedFiles);
                        }}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button
                disabled={loading}
                isLoading={loading}
                className="ml-auto"
                type="submit"
              >
                {action}
              </Button>
            </form>
          </Form>
        </div>
      </div>
    </>
  );
};
